export default {
    baseStyle: {
        wrapper: {
            background: 'white',
            flex: 1,
            padding: '45px 0 80px 0'
        },
        flex: {
            direction: {
                base: 'column',
                lg: 'row'
            },
            gap: '50px'
        },
        column: {
            flex: {
                base: '1',
                lg: '2'
            },
            stack: {
                spacing: '4',
                margin: {
                    base: '0 1rem',
                    lg: '0'
                }
            },
            review: {
                pt: 3,
                display: {
                    base: 'none',
                    lg: 'block'
                }
            }
        },
        summary: {
            flex: '1',
            display: {
                base: 'none',
                md: 'block'
            },
            review: {
                display: {
                    base: 'none',
                    lg: 'block'
                },
                pt: 2
            }
        },
        review: {
            display: {
                lg: 'none'
            },
            position: 'sticky',
            bottom: 0,
            px: 4,
            pt: 6,
            pb: 11,
            background: 'white',
            borderTop: '1px solid',
            borderColor: 'gray.100'
        },
        promocodetext: {
            padding: '1rem'
        },
        errorOuterBox: {
            color: 'white',
            p: 4,
            bg: '#1a1a1a',
            borderRadius: 'lg',
            display: 'flex',
            alignItems: 'center',
            boxShadow: 'md',
            mb: 4,
            w: 'full',
            maxW: '1200px',
            mx: 'auto'
        },
        errorInnerBox: {
            color: 'white',
            bg: '#E5002B',
            minW: '24px',
            H: '24px',
            borderRadius: 'full',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            mr: 3,
            fontSize: 'sm',
            fontWeight: 'bold'
        }
    }
}
